module.exports = __webpack_public_path__ + "img/0b65566273dd4dc5947d238189bc0774.png";